// Mock project data - Replace with your actual projects
export const projects = [
  {
    id: 1,
    slug: "fintrack-dashboard",
    title: "FinTrack Dashboard",
    category: "Product Design",
    description: "A comprehensive financial tracking dashboard designed for millennials to manage investments, budgets, and savings goals.",
    thumbnail: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&q=80",
    year: "2024",
    role: "Lead Product Designer",
    duration: "3 months",
    tools: ["Figma", "Protopie", "Maze"],
    overview: "FinTrack needed a complete redesign of their mobile and web dashboard to improve user engagement and help users better understand their financial health.",
    challenge: "Users were overwhelmed by complex financial data and struggled to take actionable steps toward their financial goals.",
    solution: "I designed a clean, card-based interface with progressive disclosure, personalized insights, and gamified savings challenges to make finance approachable.",
    outcomes: [
      "42% increase in daily active users",
      "3.2x improvement in goal completion rates",
      "NPS score improved from 32 to 67"
    ]
  },
  {
    id: 2,
    slug: "medconnect",
    title: "MedConnect",
    category: "UX Research & Design",
    description: "Telehealth platform connecting patients with healthcare providers, focusing on accessibility and ease of use for elderly users.",
    thumbnail: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=1200&q=80",
    year: "2024",
    role: "UX Designer",
    duration: "4 months",
    tools: ["Figma", "UserTesting", "Optimal Workshop"],
    overview: "MedConnect wanted to expand their user base to include elderly patients who often struggle with technology.",
    challenge: "Existing telehealth solutions were designed for tech-savvy users, leaving elderly patients frustrated and dependent on family members.",
    solution: "Through extensive user research with 50+ elderly participants, I designed a simplified interface with large touch targets, voice commands, and a one-tap appointment system.",
    outcomes: [
      "89% task completion rate for users 65+",
      "Reduced support calls by 60%",
      "Featured in Healthcare Design Magazine"
    ]
  },
  {
    id: 3,
    slug: "bloom-learning",
    title: "Bloom Learning",
    category: "Mobile App Design",
    description: "An educational app for children aged 6-12, making learning interactive and fun through gamification and adaptive content.",
    thumbnail: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=1200&q=80",
    year: "2023",
    role: "Product Designer",
    duration: "6 months",
    tools: ["Figma", "Principle", "Lottie"],
    overview: "Bloom needed a mobile app that could compete with entertainment apps for children's attention while delivering educational value.",
    challenge: "Children have short attention spans and quickly abandon apps that feel like traditional learning tools.",
    solution: "I created a playful, character-driven experience with micro-rewards, story-based lessons, and parent dashboards for tracking progress.",
    outcomes: [
      "4.8 star rating on App Store",
      "2M+ downloads in first year",
      "Average session time of 22 minutes"
    ]
  },
  {
    id: 4,
    slug: "workspace-os",
    title: "Workspace OS",
    category: "Enterprise Design",
    description: "A unified workspace platform for remote teams, integrating communication, project management, and documentation.",
    thumbnail: "https://images.unsplash.com/photo-1497215842964-222b430dc094?w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1497215842964-222b430dc094?w=1200&q=80",
    year: "2023",
    role: "Senior UX Designer",
    duration: "8 months",
    tools: ["Figma", "Miro", "FullStory"],
    overview: "A Fortune 500 company needed to consolidate 7 different tools into one cohesive platform for their 10,000+ remote employees.",
    challenge: "Employees were spending 3+ hours daily switching between tools, leading to context loss and reduced productivity.",
    solution: "I designed a modular workspace with customizable layouts, universal search, and smart notifications that reduced tool-switching friction.",
    outcomes: [
      "Saved 2.5 hours per employee per day",
      "$4.2M annual productivity savings",
      "92% employee adoption rate"
    ]
  },
  {
    id: 5,
    slug: "ecotracker",
    title: "EcoTracker",
    category: "Consumer App",
    description: "A sustainability app helping users track and reduce their carbon footprint through daily habits and community challenges.",
    thumbnail: "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=1200&q=80",
    year: "2023",
    role: "Lead Designer",
    duration: "5 months",
    tools: ["Figma", "Spline", "Mixpanel"],
    overview: "EcoTracker wanted to make sustainability accessible and engaging for everyday consumers who feel overwhelmed by climate change.",
    challenge: "Most sustainability apps focus on guilt and statistics, which leads to user disengagement and eco-anxiety.",
    solution: "I designed a positive, progress-focused experience with visual impact trees, community challenges, and partnerships with local sustainable businesses.",
    outcomes: [
      "500K+ monthly active users",
      "78% monthly retention rate",
      "Partnership with 200+ eco-brands"
    ]
  },
  {
    id: 6,
    slug: "artisan-marketplace",
    title: "Artisan Marketplace",
    category: "E-commerce Design",
    description: "A curated marketplace connecting independent artisans with conscious consumers seeking handmade, sustainable products.",
    thumbnail: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=1200&q=80",
    year: "2022",
    role: "UX/UI Designer",
    duration: "4 months",
    tools: ["Figma", "Shopify", "Hotjar"],
    overview: "A startup wanted to create an Etsy alternative focused on premium artisan goods with a stronger emphasis on storytelling.",
    challenge: "Generic e-commerce platforms fail to convey the craftsmanship and stories behind handmade products.",
    solution: "I designed rich product pages with artisan profiles, process videos, and a 'meet the maker' feature that creates emotional connections.",
    outcomes: [
      "35% higher conversion than industry average",
      "Average order value of $127",
      "Featured in Fast Company"
    ]
  },
  {
    id: 7,
    slug: "mindful-moments",
    title: "Mindful Moments",
    category: "Wellness App",
    description: "A meditation and mindfulness app designed specifically for busy professionals with just 5 minutes to spare.",
    thumbnail: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1200&q=80",
    year: "2022",
    role: "Product Designer",
    duration: "3 months",
    tools: ["Figma", "After Effects", "Amplitude"],
    overview: "Research showed that professionals want to meditate but feel existing apps require too much time commitment.",
    challenge: "Competing apps offer 10-30 minute sessions that don't fit into packed schedules, leading to guilt and abandonment.",
    solution: "I designed micro-meditation experiences (1-5 minutes) with calendar integration, meeting transition rituals, and desk-friendly exercises.",
    outcomes: [
      "68% of users meditate daily (vs 23% industry avg)",
      "4.9 star rating",
      "Acquired by major wellness brand"
    ]
  },
  {
    id: 8,
    slug: "citypulse",
    title: "CityPulse",
    category: "Civic Tech",
    description: "A civic engagement platform helping residents connect with local government, report issues, and participate in community decisions.",
    thumbnail: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=800&q=80",
    heroImage: "https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=1200&q=80",
    year: "2022",
    role: "UX Lead",
    duration: "6 months",
    tools: ["Figma", "Maze", "Google Analytics"],
    overview: "A city government wanted to increase citizen participation in local decisions and improve responsiveness to community issues.",
    challenge: "Existing civic platforms were bureaucratic, slow, and didn't provide feedback, leading to citizen distrust.",
    solution: "I designed a transparent, social-media-inspired platform with real-time issue tracking, community voting, and direct communication channels.",
    outcomes: [
      "400% increase in civic participation",
      "Issue resolution time reduced by 65%",
      "Adopted by 12 additional cities"
    ]
  }
];

// Helper to find project by slug
export const getProjectBySlug = (slug) => {
  return projects.find(p => p.slug === slug);
};

export default projects;
